<div [@animator]="index()" #carousel [style.height.px]="(height() + 25) * rows()" class="carousel-container" (mouseover)="pause()" (mouseout)="play()">
  @if(brands()?.length){
    @for(brand of currentBrands(); track brand._id; let i = $index){
      <a class="carousel-item" [routerLink]="['/brands', brand.slug]" [attr.aria-label]="brand.name" [style.width.px]="width()" [style.height.px]="height()">
        <img draggable="false" [src]="brand.logo_url | bucket: true" class="carousel-logo" [class.squared]="squared()" [alt]="brand.name" [fallback] />
      </a>
    }
  } @else {
    @for(slot of empty(); let i = $index; track i){
      <a class="loading" aria-label="Loading..." [style.width.px]="width()" [style.height.px]="height()">
        <div class="carousel-logo" [class.carousel-loader]="!!brands()" [class.squared]="squared()"></div>
      </a>
    }
  }
</div>